import { ChangeDetectionStrategy, Component, computed } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { IFilterAngularComp } from 'ag-grid-angular'
import { IFilterParams } from 'ag-grid-community'

import { FlxThemeModule } from '@flowx/angular-theme'
import { FlxRadioModule } from '@flowx/angular-ui-toolkit'

@Component({
  selector: 'flx-boolean-filter',
  imports: [FormsModule, FlxRadioModule, FlxThemeModule],
  templateUrl: './boolean-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './boolean-filter.component.scss',
})
export class BooleanFilterComponent implements IFilterAngularComp {
  private params: IFilterParams
  public selectedValue: boolean

  localeText = computed(() => this.params.api.getGridOption('localeText'))

  resetLabel = computed(() => this.localeText()?.resetFilter || 'Reset')

  trueLabel = computed(() => this.localeText()?.true || 'True')
  falseLabel = computed(() => this.localeText()?.false || 'False')

  agInit(params: IFilterParams): void {
    this.params = params
  }

  onFilterChanged(event: any): void {
    this.selectedValue = event.target.value === 'true'
    this.params.filterChangedCallback()
  }

  isFilterActive(): boolean {
    return this.selectedValue !== null
  }

  doesFilterPass(): boolean {
    return true
  }

  getModel(): any {
    return { filter: this.selectedValue, filterType: 'boolean', type: 'equals' }
  }

  setModel(model: any): void {
    this.selectedValue = model ? model.filter : null
  }

  resetFilter(): void {
    this.selectedValue = null
    this.params.filterChangedCallback()
  }
}
